###
Note Control handles quantization, duration, accidentals.

Views connect the UI to the model.
###

Observable from @danielx/observable

Template from ../templates/note-control

export NoteControl := (model: Player) ->
  model.accidentalModifier ?= Observable 0
  model.quantize ?= Observable 1/4

  // View State
  tripletMode := Observable false

  self :=
    accidentalModifier: model.accidentalModifier
    quantize: model.quantize

    natural: ->
      self.accidentalModifier 0
    sharp: ->
      self.accidentalModifier 1
    flat: ->
      self.accidentalModifier -1

    naturalActive: ->
      "active" if self.accidentalModifier() is 0
    sharpActive: ->
      "active" if self.accidentalModifier() is 1
    flatActive: ->
      "active" if self.accidentalModifier() is -1

    quarter: ->
      if tripletMode()
        self.quantize 2/3
      else
        self.quantize 1
    eight: ->
      if tripletMode()
        self.quantize 1/3
      else
        self.quantize 1/2
    sixteenth: ->
      if tripletMode()
        self.quantize 1/6
      else
        self.quantize 1/4
    triplet: ->
      q := self.quantize()
      if tripletMode()
        tripletMode false
        self.quantize q * 3/2
      else
        tripletMode true
        self.quantize q * 2/3

    // Assuming 3/4 4/4 or 5/4 time signatures for now
    quarterActive: ->
      q := self.quantize()

      if q is 1 or q is 2/3
        "active"

    eigthActive: ->
      q := self.quantize()

      if q is 1/2 or q is 1/3
        "active"
    sixteenthActive: ->
      q := self.quantize()

      if q is 1/4 or q is 1/6
        "active"

    tripletActive: ->
      "active" if tripletMode()

    durationInput: Observable model.defaultDuration._value

    quantizeInput: Observable model.quantize._value

    element: null as! HTMLElement

  model.quantize.observe (value) ->
    self.quantizeInput value

  self.quantizeInput.observe (value) ->
    v := parseFloat(value)
    if isFinite(v)
      self.quantize v

  model.defaultDuration.observe (value) ->
    self.durationInput value

  self.durationInput.observe (value) ->
    v := parseFloat(value)
    if isFinite(v)
      model.defaultDuration v

  self.element = Template(self)

  return self

export default NoteControl
